import { render, staticRenderFns } from "./comSwiper.vue?vue&type=template&id=268dba7b&scoped=true"
import script from "./comSwiper.vue?vue&type=script&lang=js"
export * from "./comSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268dba7b",
  null
  
)

export default component.exports